module.exports = __webpack_public_path__ + "img/supplier-img.493c323f.png";